import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { AnalyzeTripService } from "../../../services/analyze-trip.service";
import { toCamel } from "snake-camel";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { CoreService } from "../../../services/migrate/api.core.service";
import { USER_DATA } from "../../../utils/constants.util";
import { ToolsService } from "../../../services/migrate/tools.service";
import { Empresa } from "../../../models/markerModel";
import { STORAGE_KEY_CURRENT_USER } from "../../../storageCore/constStorageKeys";
import storageX from "../../../storageCore/storageX";

import { SearchComponent } from "../../../components/maps/search/search.component";
import { MatDialog } from "@angular/material/dialog";
import { MonitoringModel } from "../../../models/monitoring-model";
import { MonitoringDestinationsModel } from "../../../models/monitoring-destinations-model";

@Component({
  selector: "app-monitoring-request-create",
  templateUrl: "./monitoring-request-create.component.html",
  styleUrls: ["./monitoring-request-create.component.scss"],
})
export class MonitoringRequestCreateComponent implements OnInit {
  public analyzeTripService: AnalyzeTripService;
  public serviceCore: CoreService;

  public monitoringModel: MonitoringModel;

  public controlCompanyName = new FormControl({ value: "", disabled: true });

  public controlCompany = new FormControl();
  public controlDriver = new FormControl();
  public controlVehicle = new FormControl();

  public companys = new Array<any>();
  public companysFiltered = new Observable<Array<any>>();
  public vehicles = new Array<any>();
  public vehiclesFiltered = new Observable<Array<any>>();
  public drivers = new Array<any>();
  public driversFiltered = new Observable<Array<any>>();

  public companiesFilter: any = [];
  public companiesSelect: any = [];
  public typeAnalyzeSelect: any = [];
  public supervisorAvailable: any[] = [];
  public selectedSupervisor: any[] = [];
  public managerAvailable: any[] = [];
  public selectedManager: any[] = [];

  public reportOperationalForm: FormGroup;

  public companyFilterSelected;
  public typeAnalyzeFilterSelected;
  public typesReportSelected;

  public errorMessage;

  ngOnInit(): void {
    this.loadDataElements();

    this.reportOperationalForm = this.formBuilder.group({
      selectCompany: [""],
      selectTypeAnalyze: ["", Validators.required],
      expectedDepartureDate: ["", Validators.required],
      driverName: [""],
      address: ["", Validators.required],
      latitude: ["", Validators.required],
      longitude: ["", Validators.required],
      listDestination: this.formBuilder.array([]), // Inicializa o FormArray
    });

    this.companysFiltered = this.controlCompany.valueChanges.pipe(
      map((value) => (typeof value === "string" ? value : value.id)),
      map((name) =>
        name ? this.filterValuesCompany(name) : this.companys.slice()
      )
    );

    this.vehiclesFiltered = this.controlVehicle.valueChanges.pipe(
      map((value) => (typeof value === "string" ? value : value.cdPlaca)),
      map((name) =>
        name ? this.filterValuesTerminal(name) : this.vehicles.slice()
      )
    );

    this.driversFiltered = this.controlDriver.valueChanges.pipe(
      map((value) => (typeof value === "string" ? value : value.nmNome)),
      map((name) =>
        name ? this.filterValuesDriver(name) : this.drivers.slice()
      )
    );

    this.controlVehicle.valueChanges.subscribe((value) => {
      if (typeof value === "object" && value.cdPlaca) {
        this.onVehicleSelected(value); // Chama o método ao detectar um objeto válido
      }
    });
  }

  constructor(
    private tools: ToolsService,
    private formBuilder: FormBuilder,
    private router: Router,
    private spinner: NgxSpinnerService,
    analyzeTripService: AnalyzeTripService,
    apiserviceCore: CoreService,
    private dialog: MatDialog
  ) {
    this.serviceCore = apiserviceCore;
    this.analyzeTripService = analyzeTripService;
  }

  onVehicleSelected(selectedVehicle: any): void {
    if (selectedVehicle && selectedVehicle.cdPlaca) {
      console.log("Placa selecionada:", selectedVehicle);

      // Preenche o nome da empresa no campo correspondente
      if (selectedVehicle.nmempresa) {
        this.controlCompanyName.setValue(selectedVehicle.nmempresa);
        console.log("Nome da empresa:", selectedVehicle.nmempresa);
      } else {
        this.controlCompanyName.setValue(selectedVehicle.nmdivisao);
        console.log("Nome da divisao:", selectedVehicle.nmdivisao);
      }
    } else {
      console.log(
        "Nenhuma placa válida foi selecionada ou o valor é inválido."
      );
      this.controlCompanyName.setValue("");
    }
  }

  public filterValuesDriver(value: string): Array<any> {
    const filterValue = value.toLowerCase();
    return this.drivers
      .sort((a, b) => a.nmNome.localeCompare(b.nmNome))
      .filter((client) => client.nmNome.toLowerCase().includes(filterValue));
  }

  openOriginAddressPopup(): void {
    const dialogRef = this.dialog.open(SearchComponent, {
      width: "400px",
      data: { mode: "fill_address" },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.reportOperationalForm.patchValue({
          address: result.address,
          latitude: result.latitude,
          longitude: result.longitude,
        });
      }
    });
  }

  public async loadDataElements() {
    try {
      this.tools.builder().spinner.show();

      const companys = await this.serviceCore.get<any>({
        url: "v2/companys",
        params: {
          profileId: USER_DATA().profileId,
          size: "5000",
          page: "0",
          sort: "nome",
          sortDirections: "ASC",
        },
      });

      this.companys = companys?.elements;
      this.companys = this.companys.sort((a, b) =>
        a.nmNome.localeCompare(b.nmNome)
      );
      this.controlCompany.setValue("");

      const drivers = await this.serviceCore.get<any>({
        url: "v2/drivers/getAll",
        params: {
          profileId: USER_DATA().profileId,
          size: "5000",
          page: "0",
          sort: "nome",
          sortDirections: "ASC",
        },
      });

      this.drivers = drivers.elements;
      this.drivers = this.drivers.sort((a, b) =>
        a.nmNome.localeCompare(b.nmNome)
      );
      this.controlDriver.setValue("");

      const terminals = await this.serviceCore.get<any>({
        url: "v2/terminals",
        params: {
          profileId: USER_DATA().profileId,
          size: "5000",
          page: "0",
          sortDirections: "ASC",
        },
      });

      this.vehicles = terminals.elements;
      this.vehicles = this.vehicles.sort((a, b) =>
        a.cdPlaca.localeCompare(b.cdPlaca)
      );
      this.controlVehicle.setValue("");

      this.companiesSelect = [
        { name: "Divisão", value: 1 },
        { name: "Matriz", value: 2 },
        { name: "Filial", value: 3 },
      ];

      this.typeAnalyzeSelect = [
        { name: "Análise Operacional Motorista", value: "DRIVER_OPERATIONAL" },
        { name: "Análise Operacional Veiculo", value: "VEHICLE_OPERATIONAL" },
      ];

      this.tools.builder().spinner.hide();
    } catch (error) {
      this.tools.builder().spinner.hide();
      throw new EvalError(error);
    }
  }

  addDestination(): void {
    const dialogRef = this.dialog.open(SearchComponent, {
      width: "400px",
      data: { mode: "fill_address" },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // Adiciona o novo destino ao formArray
        const destinos = this.reportOperationalForm.get(
          "listDestination"
        ) as FormArray;
        destinos.push(
          this.formBuilder.group({
            address: [result.address, Validators.required],
            latitude: [result.latitude, Validators.required],
            longitude: [result.longitude, Validators.required],
          })
        );
      }
    });
  }

  someComplete(task: any): boolean {
    // Implemente a lógica para verificar se alguma subtarefa está completa
    return task.subtasks.some((subtask: any) => subtask.completed);
  }

  displayCompany(empresa: Empresa): string {
    return empresa && empresa.nmNome ? empresa.nmNome : "";
  }

  displayDriver(motorista: any): string {
    return motorista && motorista.nmNome ? motorista.nmNome : "";
  }

  displayTerminal(terminal: any): string {
    var terminalPlaca = terminal.cdPlaca ? terminal.cdPlaca : "";
    var terminalFrota = terminal.frota ? terminal.frota : "";

    return terminal && terminal.cdPlaca
      ? terminalPlaca + "/" + terminalFrota
      : "";
  }

  get destinationItems() {
    return this.reportOperationalForm.get("listDestination") as FormArray;
  }

  // Método para adicionar um novo endereço ao FormArray
  addDestinationItem(): void {
    this.destinationItems.push(
      this.formBuilder.group({
        destinationId: [null], // Campo oculto
        address: ["", Validators.required], // Campo de endereço obrigatório
      })
    );
  }

  // Método para remover um endereço do FormArray
  deleteDestinationItem(index: number): void {
    const destinos = this.reportOperationalForm.get(
      "listDestination"
    ) as FormArray;
    destinos.removeAt(index);
  }

  public filterValuesTerminal(value: string): Array<any> {
    const filterValue = value.toLowerCase();
    return this.vehicles
      .sort((a, b) => a.cdPlaca.localeCompare(b.cdPlaca))
      .filter((client) => client.cdPlaca.toLowerCase().includes(filterValue));
  }

  public filterCompany() {
    this.controlCompany.setValue("");
    var companyModel = this.companyFilterSelected;
    var empresas: any = [];

    if (companyModel == "Divisão") {
      this.companys.forEach((element: any) => {
        if (element.cnpj == null) {
          empresas.push(element);
        }
      });
    }

    if (companyModel == "Matriz") {
      this.companys.forEach((element: any) => {
        if (element.cnpj != null && element.idEmpresaMatriz == null) {
          empresas.push(element);
        }
      });
    }

    if (companyModel == "Filial") {
      this.companys.forEach((element) => {
        if (element.cnpj != null && element.idEmpresaMatriz != null) {
          empresas.push(element);
        }
      });
    }

    this.companiesFilter = empresas;

    this.companysFiltered.subscribe(this.companiesFilter);
  }

  public filterValuesCompany(value: any): Array<any> {
    const filterValue = value;

    if (this.controlCompany.value.cnpj != null) {
      if (value != null) {
        this.loadFilterCompany(value);
      }
    } else {
      if (value != null) {
        this.loadFilterDivision(value);
      }
    }

    return this.companys
      .sort((a, b) => a.nmNome.localeCompare(b.nmNome))
      .filter((client) => client.nmNome.toLowerCase().includes(filterValue));
  }

  public async loadFilterCompany(value: any) {
    try {
      this.tools.builder().spinner.show();

      const drivers = await this.serviceCore.get<any>({
        url: "v2/drivers/findByCompany",
        params: {
          profileId: USER_DATA().profileId,
          idEmpresa: value,
          size: "5000",
          page: "0",
          sort: "nome",
          sortDirections: "ASC",
        },
      });

      this.drivers = drivers.elements;
      this.drivers = this.drivers.sort((a, b) =>
        a.nmNome.localeCompare(b.nmNome)
      );

      this.controlDriver.setValue("");

      this.tools.builder().spinner.hide();
    } catch (error) {
      this.tools.builder().spinner.hide();
      throw new EvalError(error);
    }
  }

  public async loadFilterDivision(value: any) {
    try {
      this.tools.builder().spinner.show();

      const drivers = await this.serviceCore.get<any>({
        url: "v2/drivers/findByDivision",
        params: {
          profileId: USER_DATA().profileId,
          idDivisao: value,
          size: "5000",
          page: "0",
          sort: "nome",
          sortDirections: "ASC",
        },
      });

      this.drivers = drivers.elements;
      this.drivers = this.drivers.sort((a, b) =>
        a.nmNome.localeCompare(b.nmNome)
      );

      this.controlDriver.setValue("");

      this.tools.builder().spinner.hide();
    } catch (error) {
      this.tools.builder().spinner.hide();
      throw new EvalError(error);
    }
  }

  public async submitForm(): Promise<void> {
    this.spinner.show();

    const values = this.reportOperationalForm.value;

    var expectedDepartureDate: string = values.expectedDepartureDate + ":00";

    var monitoringModel: MonitoringModel = new MonitoringModel();

    //Origem da monitoração
    monitoringModel.expectedDepartureDate = expectedDepartureDate;
    monitoringModel.address = values.address;
    monitoringModel.longitude = values.longitude;
    monitoringModel.latitude = values.latitude;

    monitoringModel.driverName = values.driverName;

    if (this.controlDriver.value != "") {
      console.log(this.controlDriver.value);
      monitoringModel.idDriver = this.controlDriver.value.id;
    }

    if (this.typeAnalyzeFilterSelected == "DRIVER_OPERATIONAL") {
      if (this.controlCompany.value.cnpj != null) {
        monitoringModel.idCompany = this.controlCompany.value.id;
        monitoringModel.idDivision = 0;
      } else {
        monitoringModel.idDivision = this.controlCompany.value.id;
        monitoringModel.idCompany = 0;
      }
    } else {
      // Busca o nome da empresa ou divisão no input
      const companyName = this.controlCompanyName.value;

      // Tenta encontrar primeiro como empresa
      const filteredCompany = this.companys.find(
        (company) => company.nmNome === companyName && company.cnpj != null
      );

      if (filteredCompany) {
        monitoringModel.idCompany = filteredCompany.id;
        monitoringModel.idDivision = 0;
        console.log("Empresa encontrada:", filteredCompany);
      } else {
        // Caso não seja uma empresa, tenta encontrar como divisão
        const filteredDivision = this.companys.find(
          (division) => division.nmNome === companyName && division.cnpj == null
        );

        if (filteredDivision) {
          monitoringModel.idDivision = filteredDivision.id;
          monitoringModel.idCompany = 0;
          console.log("Divisão encontrada:", filteredDivision);
        }
      }
    }

    monitoringModel.userId = storageX
      .whereKeyIs(STORAGE_KEY_CURRENT_USER)
      .get()?.id;

    // Preenche destinos com base no FormArray
    const destinosFormArray = this.reportOperationalForm.get(
      "listDestination"
    ) as FormArray;
    const monitoringDestinations: MonitoringDestinationsModel[] =
      destinosFormArray.controls.map((control) => {
        return {
          address: control.get("address")?.value,
          latitude: control.get("latitude")?.value,
          longitude: control.get("longitude")?.value,
        } as MonitoringDestinationsModel;
      });
    monitoringModel.monitoringDestinations = monitoringDestinations;

    if (this.controlVehicle.value != "") {
      console.log(this.controlVehicle.value);
      monitoringModel.idTerminal = this.controlVehicle.value.id;
    }

    console.log(monitoringModel);

    this.analyzeTripService.createMonitoringRequest(monitoringModel).subscribe(
      (t) => {
        this.monitoringModel = toCamel(t) as MonitoringModel;

        // Aguarda 3 segundos antes de redirecionar
        setTimeout(() => {
          this.spinner.hide();
          this.router.navigate(["/solicitacao-monitoramento"]);
        }, 3000);
      },
      (error) => {
        this.spinner.hide();
        console.error("Erro ao salvar monitoramento:", error);
      }
    );
  }
}
